import {
  COMPONENT_VALUE_TYPES as types, REGIONS, BLOGGING_SECTIONS, BACKGROUND_IMAGE_POSITION, BACKGROUND_IMAGE_SCALE
} from 'shared/constants';

const defaultProps = require('./default-props');
const SECTIONS = ['', ...BLOGGING_SECTIONS];

const slots = [
  {
    slotId: 'menu-bar',
    label: 'Menu bar'
  },
  {
    slotId: 'left-col',
    label: 'Left Column'
  },
  {
    slotId: 'header-right',
    label: 'Header Right Area'
  },
  {
    slotId: 'right-col',
    label: 'Right Column'
  },
  {
    slotId: 'footer',
    label: 'Footer area'
  }
];

const templateSettings = [
  {
    type: 'ENUM',
    key: 'region',
    label: 'Region',
    options: REGIONS
  },
  {
    type: 'ENUM',
    key: 'section',
    label: 'Section',
    options: SECTIONS
  },
  {
    type: 'STRING',
    key: 'url',
    label: 'Url',
    default: '/us/futuresight/first-po'
  },
  {
    type: 'STRING',
    key: 'title',
    label: 'Title',
    default: 'Intelligent Materials: Evolving Car Design & Sustainability'
  },
  {
    type: 'STRING',
    key: 'description',
    label: 'Description',
    default: 'Faraday Future (FF) has signed a lease on its new manufacturing facility, and began the process of clean-up…'
  },
  {
    type: types.S3_ASSET_URL,
    key: 'heroImageUrl',
    label: 'Hero Image (For Press Release, ensure uploaded image is 1920 x 1080px or 16:9 aspect ratio)',
    default: 'https://genesis-cdn.ff.com/our_company/01_people/our-people-07.jpg',
    options: {
      cropEnabled: true,
      croppers: [
        {
          name: 'mobile',
          description: 'Mobile',
          aspectRatio: '3 / 8',
        },
        {
          name: 'tablet',
          description: 'Tablet',
          aspectRatio: '4 / 3',
        },
        {
          name: 'desktop',
          description: 'Desktop',
          aspectRatio: '16 / 9',
        },
      ],
    },
  },
  {
    type: types.S3_ASSET_URL,
    key: 'heroImageUrlMobile',
    label: 'Mobile Hero Image (overrides mobile cropped hero image)',
  },
  {
    type: types.BOOLEAN,
    key: 'responsive_image',
    label: 'Use Responsive Image',
    default: false
  },
  {
    type: 'ENUM',
    key: 'background_position',
    label: 'Background Position',
    options: BACKGROUND_IMAGE_POSITION,
    default: 'CENTER CENTER'
  },
  {
    type: 'ENUM',
    key: 'background_scale',
    label: 'Background Scale',
    options: BACKGROUND_IMAGE_SCALE,
    default: 'auto'
  },
  {
    type: 'STRING',
    key: 'hero_background_color',
    label: 'Hero Background Color',
    default: ''
  },
  {
    type: 'BOOLEAN',
    key: 'featured',
    label: 'Featured',
    default: true
  },
  {
    type: 'DATE',
    key: 'published_at',
    label: 'Published At',
    default: '2017-07-19T19:51:09.878Z'
  },
  {
    type: 'STRING',
    key: 'published_by',
    label: 'Published by',
    default: 'FF Team'
  },
  {
    type: 'STRING',
    key: 'press_kit',
    label: 'Press Kit (Link)'
  },
  {
    type: 'ARRAY',
    key: 'social_share',
    label: 'Social_share',
    children: [
      {
        type: 'STRING',
        key: 'url',
        label: 'Url',
      },
      {
        type: 'STRING',
        key: 'icon',
        label: 'Icon'
      }
    ],
    default: [
      { url: 'https://www.linkedin.com/shareArticle?mini=true&url={page url}&title={article title}&summary={short description}', icon: 'ff-icon-social-linkedin' },
      { url: 'https://twitter.com/share?url={URL}&text={article title} @FaradayFuture', icon: 'ff-icon-social-twitter' },
      { url: 'https://www.facebook.com/sharer/sharer.php?u={URL}', icon: 'ff-icon-social-facebook' },
      { url: 'mailto:?subject={article title}&body={URL}', icon: 'ff-icon-mail' },
      { url: 'http://service.weibo.com/share/share.php?url={URL}&title={article title} @FaradayFuture&appkey=1343713053&pic=&searchPic=false', icon: 'ff-icon-social-weibo' },
      { url: '{URL}', icon: 'ff-icon-social-wechat' }
    ]
  },
  {
    type: 'ARRAY',
    key: 'tags',
    label: 'Tags',
    children: [
      {
        type: 'STRING',
        key: 'tag',
        label: 'Tag'
      }
    ],
    default: [
      { tag: 'Technology' },
      { tag: 'Community' },
      { tag: 'Company' }
    ]
  }
];

export default {
  id: 'FutureSightDetails',
  name: 'FutureSightDetails',
  creator: 'FF Web',
  updatedBy: 'Claire Lin',
  createdAt: 1503956140000,
  updatedAt: 1503956140000,
  slots,
  templateSettings,
  defaultProps
};
